import {securityGate} from "../../../../lib";

export default class QuestionModel {
	constructor() {
		this.index = null;
		this.answers = null;
		this.blockId = null;
		this.code = null;
		this.description = null;
		this.question = null;
		this.type = null;

		this.isAnswerCorrect = false;
		this.answered = false;
	}

	static getInstance(data) {
		const instance = new QuestionModel();
		const keys = Object.getOwnPropertyNames(data);
		keys.forEach(key => {
			if (instance.hasOwnProperty(key) && (securityGate(data[key]) || data[key] === 0)) {
				instance[key] = data[key];
			}
		});
		return instance;
	}

	setAnswer(answerList) {
		/* @param object answerList */
		this.isAnswerCorrect = true;
		this.answered = answerList;
		this.answers.forEach((answer, i) => {
			answer.answered = this.answered[i];
			if (answer.right !== this.answered[i]) {
				this.isAnswerCorrect = false;
			}
		});
	}

	getResultObj() {
		return {
			index: this.index,
			answers: this.answers,
			blockId: this.blockId,
			code: this.code,
			description: this.description,
			question: this.question,
			type: this.type,
			isAnswerCorrect: this.isAnswerCorrect
		}
	}
}